import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import PaginatedTable from "../Common/PaginatedTable";
import { Link } from "react-router-dom";
import { HiEye, HiXCircle } from "react-icons/hi";
import { Equipment } from "../../Models/Equipment";
import { formatNumbers } from "../../Utils";
import { FileTypeEnums } from "../../Models/FileType";
import blankImage from "../../Assets/NoPhoto.jpg";
import { Select, Tooltip } from "flowbite-react";
import { OrderItem } from "../../Models/OrderItem";

export default function ViewOrderTable({
  data,
  removeFromCart,
  saveForLater,
  updateItemQuantity,
}: {
  data: OrderItem[];
  removeFromCart(id: number): void;
  saveForLater(equipment: Equipment): void;
  updateItemQuantity(item: OrderItem, quantity: number): void;
}) {
  const columnHelper = createColumnHelper<OrderItem>();

  const columns = [
    columnHelper.accessor((row) => row.equipmentId, {
      id: "id",
      header: "",
      cell: (info) => (
        <div className="md:flex gap-1">
          <Link to={`/products/equipment/${info.getValue()}`}>
            <img
              key={info.row.original.id}
              src={
                info.row.original.equipment?.files &&
                info.row.original.equipment?.files?.filter(
                  (x) => x.fileTypeId === FileTypeEnums.Photo
                ).length > 0
                  ? info.row.original.equipment?.files.filter(
                      (x) => x.fileTypeId === FileTypeEnums.Photo
                    )[0].fileUrl
                  : blankImage
              }
              alt={info.row.original.equipment?.number + "-image"}
              className="h-[75px] object-contain"
            />
          </Link>
          <div className="flex flex-col justify-center">
            <i>
              Manufacturer: {info.row.original.equipment?.manufacturer?.name}
            </i>
            <i>Number: {info.row.original.equipment?.number}</i>
          </div>
        </div>
      ),
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.equipment?.price, {
      id: "price",
      header: "Price",
      cell: (info) => {
        const equipment = info.row.original.equipment;
        const isTrade = equipment?.oemvendor?.startsWith("1");
        const price = isTrade
          ? equipment?.tradePrice ?? 0
          : equipment?.special1Price ?? 0;

        return <i>${formatNumbers(price)}</i>;
      },
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.quantity, {
      id: "quantity",
      header: "Quantity",
      cell: (info) => (
        <Select
          id="quantityId"
          onChange={(e) =>
            updateItemQuantity(info.row.original, Number(e.target.value))
          }
          value={info.getValue()}
          sizing="md"
          className="w-full lg:w-1/2"
        >
          {[...Array.from({ length: 25 }, (_, i) => i + 1)].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </Select>
      ),
      size: 35,
      enableColumnFilter: false,
    }),
    // columnHelper.accessor((row) => row.equipment?.price, {
    //   id: 'priceTotal',
    //   header: 'Price Total',
    //   cell: (info) => (
    //     <i>
    //       $
    //       {formatNumbers(
    //         (info.row.original.equipment?.price ?? 1) *
    //           info.row.original.quantity
    //       )}
    //     </i>
    //   ),
    //   size: 35,
    //   enableColumnFilter: false,
    // }),
    columnHelper.accessor((row) => row.id, {
      id: "removeId",
      header: "",
      cell: (info) => (
        <div className="flex">
          <Tooltip content={"Remove from cart"}>
            <button
              type="button"
              className="buttonCancel p-2"
              onClick={() => removeFromCart(info.getValue())}
            >
              <HiXCircle />
            </button>
          </Tooltip>
          <button
            type="button"
            className="text-blue-600 rounded-md px-1 hover:bg-gray-100"
            onClick={() => saveForLater(info.row.original.equipment!)}
          >
            Save for later
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className="w-full mx-auto overflow-x-auto">
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode="onChange"
          showFilters={true}
          showPagination={false}
        />
      </div>
    </>
  );
}
